export default __webpack_public_path__ + "static/media/mail_icon.3a810c28.svg";